import React from 'react';
import { useLocationPermission } from '../context/LocationPermissionContext';
import './NearbyPlacesCard.css';

function NearbyPlacesCard({ title, image }) {
  const { requestLocation } = useLocationPermission();

  // Function to handle click on nearby places card
  const handleNearbyPlaceClick = () => {
    // Request location - will show popup if permission was denied
    requestLocation(
      (coords) => {
        const { latitude, longitude } = coords;
        // Determine search query based on the place type
        let searchQuery;

        switch (title) {
          case "Petrol Pump":
            searchQuery = "petrol+pump";
            break;
          case "Police Station":
            searchQuery = "police+station";
            break;
          case "Charging Station":
            searchQuery = "ev+charging+station";
            break;
          case "Mechanic":
            searchQuery = "car+mechanic";
            break;
          default:
            searchQuery = title.toLowerCase().replace(/\s+/g, '+');
        }

        // Create Google Maps URL with the current location and search query
        const mapsUrl = `https://www.google.com/maps/search/${searchQuery}/@${latitude},${longitude},14z`;

        // Open Google Maps in a new tab
        window.open(mapsUrl, '_blank');
      },
      (error) => {
        console.error("Error getting location: ", error);
        // Fallback - open maps without coordinates
        const searchQuery = title.toLowerCase().replace(/\s+/g, '+');
        const mapsUrl = `https://www.google.com/maps/search/${searchQuery}`;
        window.open(mapsUrl, '_blank');
      }
    );
  };

  return (
    <div className="nearby-places-card nearby-card-with-image" onClick={handleNearbyPlaceClick}>
      <h3 className="nearby-card-title">{title}</h3>
      <img src={image} alt={title} className="nearby-card-image" />
      <div className="nearby-card-arrow">
        <span>&#8599;</span>
      </div>
    </div>
  );
}

export default NearbyPlacesCard;